import { render, staticRenderFns } from "./writeOffDetails.vue?vue&type=template&id=2979d1b9&scoped=true"
import script from "./writeOffDetails.vue?vue&type=script&lang=js"
export * from "./writeOffDetails.vue?vue&type=script&lang=js"
import style0 from "./writeOffDetails.vue?vue&type=style&index=0&id=2979d1b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2979d1b9",
  null
  
)

export default component.exports